export const CARD_FILTER_URL_KEYS = ["q", "spheres", "type", "cost", "pack"];

/** Default sphere selection matches initial UI (Neutral only). */
export function isDefaultSphereSelection(spheres) {
  return spheres.length === 1 && spheres[0] === "Neutral";
}

function parseListParam(usp, key) {
  const raw = usp.get(key);
  if (raw === null || raw === "") return [];
  return raw.split(",").map((s) => s.trim()).filter(Boolean);
}

export function parseCardFiltersFromSearch(search) {
  const raw = search.startsWith("?") ? search.slice(1) : search;
  const usp = new URLSearchParams(raw);
  const q = usp.get("q") ?? "";
  const spheresParam = usp.get("spheres");
  let selectedSpheres;
  if (spheresParam === null) {
    selectedSpheres = ["Neutral"];
  } else if (spheresParam === "") {
    selectedSpheres = [];
  } else {
    selectedSpheres = spheresParam.split(",").map((s) => s.trim()).filter(Boolean);
  }
  return {
    q,
    selectedSpheres,
    selectedTypes: parseListParam(usp, "type"),
    selectedCosts: parseListParam(usp, "cost"),
    selectedPacks: parseListParam(usp, "pack"),
  };
}

export function buildCardFiltersQueryString({
  q,
  selectedSpheres,
  selectedTypes,
  selectedCosts,
  selectedPacks,
}) {
  const usp = new URLSearchParams();
  if (q) usp.set("q", q);
  if (selectedSpheres.length === 0) {
    usp.set("spheres", "");
  } else if (!isDefaultSphereSelection(selectedSpheres)) {
    usp.set("spheres", [...selectedSpheres].sort().join(","));
  }
  if (selectedTypes.length) usp.set("type", [...selectedTypes].sort().join(","));
  if (selectedCosts.length) usp.set("cost", [...selectedCosts].sort().join(","));
  if (selectedPacks.length) usp.set("pack", [...selectedPacks].sort().join(","));
  return usp.toString();
}

export function readInitialCardFilters() {
  if (typeof window === "undefined") {
    return {
      q: "",
      selectedSpheres: ["Neutral"],
      selectedTypes: [],
      selectedCosts: [],
      selectedPacks: [],
    };
  }
  return parseCardFiltersFromSearch(window.location.search);
}
